import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
`;

export const StoreLink = styled('a')`
  display: flex;
  width: 150px;
  height: 50px;
`;

export const Store = styled.img`
  display: flex;
  height: 100%;
  width: 100%;
`;

export const Buttons = styled.div`
  display: flex;
`;
